var Modal = require('components/utility/AltModal');
var CurrentUser = require('lib/account/CurrentUser');
var Owlvatar = require('components/avatars/Owlvatar');
var ShopSales = require("lib/games/ShopSales");

var moment = require("moment");

require("games/sale_modal.scss");

class SaleModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
	}

	show() {
		this.refs.modal.show();
	}

	hide() {
		this.refs.modal.hide();
	}

	render() {
		const sale = ShopSales.getCurrentSale()
		const dates = ShopSales.getSaleDates(sale)
		const saleEnd = dates["end"]
		const timeNow = new Date()

		const imagePatches = this.props.saleData.patches.map(function(patch) {
			var patches = _.clone(CurrentUser.get().avatar.patches);
			_.each(_.keys(patches), function(patchType) {
				if ((patches[patchType] != Owlvatar.NO_PATCH) && (patches[patchType].source != "default")) {
					patches[patchType] = Owlvatar.NO_PATCH;
				}
			});
			patches["feet"] = {
				"name": "short",
				"title": "Short Feet",
				"description": null,
				"source": "default",
				"patch_type": "feet",
				"origin_patch_type": "feet",
				"patch_directory": "feet",
				"z_index": 800,
				"price": 0,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}
			patches["beak"] = {
				"name": "normal",
				"title": "Normal Beak",
				"description": null,
				"source": "default",
				"patch_type": "beak",
				"origin_patch_type": "beak",
				"patch_directory": "beak",
				"z_index": 3000,
				"price": 0,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}

			patches[patch.patch_data] = patch;
			var colors = CurrentUser.get().avatar.colors;

			return (
				<div key={ patch.patch_type + patch.name } className="clearfix patchWrap">
					<Owlvatar patches={ patches } colors={ colors } maxWidth={ 120 } />
				</div>
			)
		});

		var hoursLeft = Math.abs(saleEnd - timeNow) / 36e5;
		if (hoursLeft > 72) {
			var displayUnit = (hoursLeft/ 24).toFixed(0);
			var displayUnit = displayUnit.toString() + " days "
			var timeText = "are";
		} else {
			if (hoursLeft <= 1) {
				var timeText = "is";
				var hoursLeft = 1;
				var displayUnit = hoursLeft + " hour ";
			}  else if (hoursLeft > 1) {
				var timeText = "are"
				var displayUnit = hoursLeft.toFixed(0).toString() + " hours ";
			}
			
		}

		return (
			<Modal className="saleModal wideModal" headerText={ this.props.saleData.title } 
				ref="modal" onShow={this.handleOpen}>

				<div className="data">
					<p>{ this.props.saleData.description }</p>
					<div className="clearfix text-center">
						{ imagePatches }
					</div>
					<p>Head over to the Owl Shop until <strong>{ saleEnd.toLocaleDateString() }</strong> to get these special items.
					There { timeText } <strong>{ displayUnit }</strong>left!</p>
				</div>
			</Modal>
		);
	}
}

SaleModal.propTypes = PageStrictPropTypes({
	saleData: PropTypes.object.isRequired,
});

module.exports = SaleModal;


// WEBPACK FOOTER //
// ./modules/components/games/SaleModal.js